import { apiClient } from './client';
import { extractItemsFromResponse, extractPagedItemsAndTotal, handleApiError } from './utils';

export const fetchAllNotifications = async ({
    apiEndpoint,
    params = {}
}) => {
    const requestParams = {
        count: params.count || 10,
        ...params
    };

    try {
        const response = await apiClient.get(apiEndpoint, { params: requestParams });

        let items = [];
        const { rawItems, total } = extractPagedItemsAndTotal(response.data);

        if (Array.isArray(rawItems)) {
            items = rawItems.map(item => {
                if (item && item.id !== undefined) {
                    return {
                        id: item.id,
                        title: item.title || 'Başlıksız Bildirim',
                        message: item.text || item.message || '',
                        created: item.created,
                        isRead: item.hasRead === true,
                    };
                } else {
                    return null;
                }
            }).filter(item => item !== null);
        }

        return { items, total };

    } catch (error) {
        handleApiError(error, 'Bildirimler alınırken bir hata oluştu.');
        return { items: [], total: 0 };
    }
};

export const fetchNotificationById = async (apiEndpoint, id) => {
    try {
        const response = await apiClient.get(`${apiEndpoint}/${id}`);
        const responseData = extractItemsFromResponse(response.data);
        const notification = Array.isArray(responseData) ? responseData[0] : responseData;

        if (notification && notification.id !== undefined) {
            return {
                id: notification.id,
                title: notification.title || 'Başlıksız Bildirim',
                message: notification.text || notification.message || '',
                created: notification.created,
                isRead: notification.hasRead === true,
                details: notification.details || '',
                priority: notification.priority || 'normal',
                type: notification.type || 'info'
            };
        }

        return null;
    } catch (error) {
        handleApiError(error, 'Bildirim alınırken bir hata oluştu.');
        throw error;
    }
};
